import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import type { FormItemProps as AntdFormItemProps, FormInstance } from 'antd'
import { Form as AntdForm } from 'antd'
import type { ReactNode } from 'react'

import { type ValidationRulesKeys, useFormValidationRules } from '@/hooks/useFormValidationRules'

import styles from './styles.scss'

export interface FormItemProps extends Omit<AntdFormItemProps, 'rules' | 'children'> {
  children?: ReactNode | ((form: FormInstance) => ReactNode)
  noMargin?: boolean
  validation?: ValidationRulesKeys
  tooltipType?: 'info' | 'question'
}

export function FormItem({
  children,
  noMargin,
  validation = 'noValidation',
  tooltip,
  tooltipType = 'info',
  labelCol = { span: 24 },
  ...props
}: FormItemProps) {
  const rules = useFormValidationRules()

  const marginClassname = noMargin ? styles.formItemWithoutMargin : styles.formItemWithMargin

  const tooltipIcon =
    tooltipType === 'question' ? <QuestionCircleOutlined /> : <InfoCircleOutlined />

  function checkItHasTooltip() {
    if (tooltip && typeof tooltip === 'object') {
      return { ...tooltip, icon: tooltipIcon }
    } else if (typeof tooltip === 'string') {
      return { title: tooltip, icon: tooltipIcon }
    }
  }

  return (
    <AntdForm.Item
      {...props}
      labelCol={labelCol}
      className={[marginClassname, props.className, styles.tooltipIcon].join(' ')}
      colon={false}
      rules={rules[validation]}
      tooltip={checkItHasTooltip()}
    >
      {children as ReactNode}
    </AntdForm.Item>
  )
}
